import { render } from "./Formalities.vue?vue&type=template&id=2ea3455e"
import script from "./Formalities.vue?vue&type=script&lang=js"
export * from "./Formalities.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__